<template>
    <div class="modal-card drawer_opener" id="modal_full_right">
        <header class="modal-card-head">
            <component :is="headerComp" :data="headerProps" @closeModal="() => closeModal()"></component>
        </header>
        <section class="modal_back_caa">
            <component :is="bodyComp" :data="bodyProps"></component>
        </section>
    </div>
</template>


<script>

import { mapActions } from "vuex";
export default {
    name: "ModalFullHeightRight",
    components: {
    },
    data() {
        return {
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal",
            },
        };
    },
    methods: {
        ...mapActions("classification", ["getIfHasNewDocs"]),
        closeModal() {
            const modal = document.querySelector('#modal_full_right.modal-card.drawer_opener');
            if (modal) {
                modal.classList.remove('drawer_animation');
                modal.classList.remove('drawer_closed');
                setTimeout(() => {
                    this.$emit('close');
                }, 150);
            } else {
                this.$emit('close');
            }
        },
        openModalAnimation() {
            this.$nextTick(() => {
                const drawerElement = document.querySelector(
                    '#modal_full_right.modal-card.drawer_opener'
                );

                if (drawerElement) {
                    drawerElement.classList.add('drawer_animation');
                } else {
                    console.warn('Element with id "modal_full_right" not found.');
                }
            });
        },
    },
    mounted() {
        this.openModalAnimation()
    },
    beforeDestroy() {
        this.getIfHasNewDocs()
        this.$emit('closeModalFn')
    },
    watch: {

    },
    props: {
        headerComp: Object,
        bodyComp: Object,
        headerProps: Object,
        bodyProps: Object,
    }
};
</script>

<style scoped lang="scss">
* {
    font-family: Inter;
}

.modal_back_caa {
    background-color: #fcfcfd;
    padding: 32px;
    overflow-y: scroll;
}

.drawer_opener {
    position: absolute !important;
    top: 0 !important;
    height: 100% !important;
    max-height: 100% !important;
    background: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    transition: right 0.35s ease-in-out;
    z-index: 1050;
    width: 85%;
}

.drawer_animation {
    right: 0px !important;
}

.drawer_closed {
    right: -3000px !important;
}
</style>
